const notprodWholeIndicators = ['0', '10', '127', '192', 'localhost', 'test']
const devServersPartials = ['dev-', '-dev']
const stagingServesPartials = ['stg-', '-stg', 'stage-', '-stage']
const qaServersPartials = ['qa-', '-qa']
const reviewServersPartials = ['review-', '-review', 'rev-', '-rev']
const notprodFragmentIndicators = [].concat(
  devServersPartials,
  stagingServesPartials,
  qaServersPartials,
  reviewServersPartials
)
const prodOverrides = ['.com/Apps/']

export default (hostname = null) => {
  let isNotProd = false
  let prodOverrideDetected = false
  const host = (hostname || window.location.hostname)
  const hostnameParts = host.split('.')
  const href = window.location.href

  if (!prodOverrideDetected) {
    prodOverrides.forEach(override => {
      if (href.indexOf(override) > -1 && host.indexOf('ecs') > -1) {
        prodOverrideDetected = true
      }
    })
  }

  hostnameParts.forEach(part => {
    if (!isNotProd) {
      notprodWholeIndicators.forEach(notProdIndicator => {
        if (part === notProdIndicator) isNotProd = true
      })

      notprodFragmentIndicators.forEach(notProdIndicator => {
        if (part.indexOf(notProdIndicator) > -1) isNotProd = true
      })
    }
  })

  return isNotProd && !prodOverrideDetected ? 'notprod' : 'prod'
}
